import { useEffect, useState } from 'react';
import logo from '../../../images/logo.svg';
import home from '../../../images/home.svg';
import services from '../../../images/services.svg';
import config from '../../../images/config.svg';
import administracion from '../../../images/administracion.svg';
import plus from '../../../images/plus.svg';
import threedots from '../../../images/threedots.svg';
import navOptionArrow from '../../../images/navOptionArrow.svg';
import { NavLink, useHistory } from 'react-router-dom';
import authService from '../../../services/authService';
import { notify } from '../../../assets/helpers/toast';
import {
  readRole,
  salesRoles,
  transcriptRoles,
} from '../../../assets/helpers/roles';
import { LogOutModal } from '../../../components/common/Modals/Modals';
import auth from '../../../services/authService';
import { connectSocket, disconnectSocket } from '../../../services/socketService';
import { useInboxCountStore } from '../../../stores/inboxCountStore';
import { useSocketConnectionStore } from '../../../stores/socketConnectionStore';
import './Header.scss';
import { updateHistoryAllowed } from '../../../assets/helpers/emails';

import letter from "../../../images/letter.png";
import { ActionButton } from '../Buttons/Buttons';

const GIFTCARDsALES = 'Venta de Giftcards';
const CURRENCYRATE = 'Tasa de cambio';
const ADVANCED_PAYMENTS = 'Cobros Anticipados';

const {
  SALES_DEVELOPER,
  SALES_ADMIN,
  SALES_SUPERVISOR,
  SALES_HUNTER,
  SALES_FARMER,
  SALES_COUNTER,
  SALES_MARKETING,
  SALES_ADMIN_AUX,
  EVENTS,
  RCV,
  SALES_RCV_SCORP,
  SALES_KEY_ACCOUNTS,
} = salesRoles;

const linksVentas = [
  {
    name: 'Dashboard',
    link: 'dashboard',
    src: home,
    levels: [
      {
        name: 'Analíticas',
        url: 'analytics',
        sublevels: [
          {
            name: 'Base de Afiliaciones',
            url: 'afiliations/status/all/none',
            // roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR],
          },
          {
            name: 'Documentacion Pendiente',
            url: 'afiliations/status/pending-documentation/6a0f1782f2e501854fe44546',
            // roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR],
          },
          {
            name: 'Pendiente de aprobacion',
            url: 'afiliations/status/pendiente-de-aprobacion/649618416f99995f1d3dabb3',
          },
          {
            name: 'Vencido',
            url: 'afiliations/status/vencido/649618426f99995f1d3dabbf',
          },
          {
            name: 'Rescate',
            url: 'afiliations/status/rescate/654d8c37ead3204963a96b3f',
          },
          {
            name: 'Anulado',
            url: 'afiliations/status/anulado/649618426f99995f1d3dabc2',
          },
          {
            name: 'Activo',
            url: 'afiliations/status/activo/649618416f99995f1d3dabb6',
          },
          {
            name: 'Por Renovacion',
            url: 'afiliations/status/por-renovacion/649618426f99995f1d3dabbc',
          },
        ],
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_SUPERVISOR,
          SALES_HUNTER,
          EVENTS,
          SALES_FARMER,
          SALES_COUNTER,
          SALES_ADMIN_AUX,
          SALES_KEY_ACCOUNTS,
        ],
      },
      {
        name: 'Módulo de Renovación',
        url: 'afiliations/renewal/all',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_SUPERVISOR,
          SALES_HUNTER,
          EVENTS,
          SALES_FARMER,
          SALES_COUNTER,
          SALES_KEY_ACCOUNTS
        ],
      },
      {
        name: 'Afiliados PAP',
        url: 'pap-affiliated',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_ADMIN_AUX,
          SALES_SUPERVISOR,
          SALES_HUNTER,
          SALES_FARMER,
          SALES_COUNTER,
          SALES_KEY_ACCOUNTS,
        ],
      },
      {
        name: 'Exportables',
        url: 'exportable',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_SUPERVISOR,
          SALES_HUNTER,
          EVENTS,
          SALES_FARMER,
          SALES_ADMIN_AUX,
          RCV,
          SALES_RCV_SCORP,
          SALES_KEY_ACCOUNTS,
        ],
      },
    ],
    roles: [
      SALES_DEVELOPER,
      SALES_ADMIN,
      SALES_SUPERVISOR,
      SALES_HUNTER,
      EVENTS,
      SALES_FARMER,
      SALES_COUNTER,
      SALES_ADMIN_AUX,
      RCV,
      SALES_RCV_SCORP,
      SALES_KEY_ACCOUNTS,
    ],
  },
  {
    name: 'Módulos',
    link: 'modules',
    src: services,
    roles: [
      SALES_DEVELOPER,
      SALES_ADMIN,
      SALES_SUPERVISOR,
      SALES_HUNTER,
      EVENTS,
      SALES_FARMER,
      SALES_COUNTER,
      SALES_ADMIN_AUX,
      SALES_MARKETING,
      SALES_KEY_ACCOUNTS,
    ],
    levels: [
      {
        name: 'Códigos de Giftcards',
        url: 'giftcard-codes',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_SUPERVISOR,
          SALES_MARKETING,
        ],
      },
      {
        name: GIFTCARDsALES,
        url: 'giftcard-sales',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_SUPERVISOR,
          SALES_MARKETING,
          // Solo Venta
          SALES_ADMIN_AUX,
          SALES_HUNTER,
          EVENTS,
          SALES_FARMER,
          SALES_COUNTER,
          SALES_KEY_ACCOUNTS,
        ],
      },
      {
        name: 'Registro de flota',
        url: 'fleet-register',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_KEY_ACCOUNTS],
      },
      {
        name: 'Clientes Potenciales',
        url: 'potential-clients',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_HUNTER, SALES_COUNTER, SALES_FARMER, SALES_KEY_ACCOUNTS],
      },
      {
        name: 'Cashea Link',
        url: 'cashea-link-deleted-orders',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          // Solo Venta
          SALES_ADMIN_AUX,
        ],
      },
    ],
  },
  {
    name: 'Administración',
    link: 'admin',
    src: administracion,
    levels: [
      {
        name: 'Cashea',
        url: 'cashea',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX],
      },
      {
        name: 'Validación de Pagos',
        url: 'validate-payments',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_ADMIN_AUX,
          SALES_SUPERVISOR,
        ],
      },
      {
        name: 'Vueltos',
        url: 'changes',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX],
      },
      {
        name: 'Comisiones de asesores',
        url: 'consultant-commissions',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX],
      },
      {
        name: 'Comisiones intermediarios',
        url: 'intermediary-commissions',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX],
      },
      {
        name: 'Cobros Anticipados',
        url: 'advanced-payments',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_ADMIN_AUX,
          SALES_FARMER,
          SALES_HUNTER,
          SALES_COUNTER,
          SALES_KEY_ACCOUNTS,
        ],
      },
    ],
    roles: [
      SALES_DEVELOPER,
      SALES_ADMIN,
      SALES_ADMIN_AUX,
      SALES_SUPERVISOR,
      SALES_COUNTER,
      SALES_HUNTER,
      SALES_FARMER,
      SALES_KEY_ACCOUNTS,
    ],
  },
  {
    name: 'Configuración',
    link: 'config',
    src: config,
    levels: [
      {
        name: 'Historial de Actualizaciones',
        url: 'update-history',
        roles: [SALES_DEVELOPER, SALES_ADMIN],
      },
      {
        name: 'Parametros',
        url: 'parameters',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_KEY_ACCOUNTS],
      },
      {
        name: CURRENCYRATE,
        url: 'exchange-rate',
        roles: [
          SALES_DEVELOPER,
          SALES_ADMIN,
          SALES_SUPERVISOR,
          SALES_HUNTER,
          EVENTS,
          SALES_FARMER,
          SALES_COUNTER,
          SALES_ADMIN_AUX,
          SALES_KEY_ACCOUNTS
        ],
      },
      { name: 'Usuarios', url: 'users', roles: [SALES_DEVELOPER, SALES_ADMIN] },
      {
        name: 'Descuentos',
        url: 'discounts',
        roles: [SALES_DEVELOPER, SALES_ADMIN],
      },
      {
        name: 'Metas',
        url: 'goals',
        roles: [SALES_DEVELOPER, SALES_ADMIN, SALES_ADMIN_AUX],
      },
    ],
    roles: [
      SALES_DEVELOPER,
      SALES_ADMIN,
      SALES_SUPERVISOR,
      SALES_HUNTER,
      EVENTS,
      SALES_FARMER,
      SALES_COUNTER,
      SALES_ADMIN_AUX,
      SALES_KEY_ACCOUNTS,
    ],
  },
  {
    name: 'Nueva afiliación',
    link: 'new-membership',
    src: plus,
    roles: [
      SALES_DEVELOPER,
      SALES_ADMIN,
      SALES_SUPERVISOR,
      SALES_HUNTER,
      EVENTS,
      SALES_FARMER,
      SALES_COUNTER,
      SALES_ADMIN_AUX,
      SALES_KEY_ACCOUNTS,
    ],
  },
];

export const LevelComponent = (props) => {
  const { history, link, level, closeFirstLevel, userRole } = props;

  const userEmail = userRole?.email;
  const isExternalCounter =
    [userRole?.roles[0]?.code].includes(SALES_COUNTER) &&
    userRole?.type === 'Externo';

  const redirectToFirstLevel = () => {
    history.push(`/` + link.link + `/${level?.url}`);
    closeFirstLevel();
  };

  const redirectToSecondLevel = (sublevel) => {
    history.push(`/` + sublevel.url);
    closeFirstLevel();
    window.location.reload();
  };
  // Si el subnivel tiene roles asignados y no incluye alguno en si lista no muestra el subnivel
  //si el subnivel no tiene roles asignados muestralo siempre
  if (level.roles?.length > 0 && !level.roles.includes(auth.getUserType())) {
    return null;
  }

  if (
    level.name === 'Historial de Actualizaciones' &&
    !updateHistoryAllowed.includes(userEmail)
  ) {
    return null;
  }

  // Counter interno no puede ver el modulo de renovacion
  // if (
  //   [userRole?.roles[0]?.code].includes(SALES_COUNTER) &&
  //   userRole?.type === 'Interno' &&
  //   [RENOVATIONMODULE]?.includes(level?.name)
  // ) {
  //   return null;
  // }
  // Counter Externo no puede "cambio de tasa" y "venta de gift cards"
  if (
    isExternalCounter &&
    [GIFTCARDsALES, CURRENCYRATE, ADVANCED_PAYMENTS]?.includes(level?.name)
  ) {
    return null;
  }

  if (isExternalCounter && level?.name === 'Afiliados PAP') {
    return null;
  }

  let sublevels = level?.sublevels || [];
  if (isExternalCounter && level?.name === 'Analíticas') {
    const isAgencyMaster = auth.isAgencyMaster();
    sublevels = sublevels
      .filter((sublevel) => sublevel?.name === 'Base de Afiliaciones')
      .map((sublevel) => ({
        ...sublevel,
        name: isAgencyMaster ? 'Ventas de mi agencia' : 'Mis ventas',
      }));
    if (isAgencyMaster) {
      sublevels.push({
        name: 'Comisiones de mi agencia',
        url: 'admin/intermediary-commissions',
      });
    }
  }

  return (
    <div>
      <div
        onClick={() => redirectToFirstLevel()}
        className="header-sublevel-option"
        key={level.name}
      >
        {level.name}
      </div>
      {sublevels?.map((s) => (
        <SubLevelComponent action={redirectToSecondLevel} sublevel={s} />
      ))}
    </div>
  );
};

export const SubLevelComponent = (props) => {
  const { action, sublevel } = props;

  if (
    sublevel?.roles?.length > 0 &&
    !sublevel?.roles?.includes(auth.getUserType())
  ) {
    return null;
  } else {
    return (
      <div
        onClick={() => action(sublevel)}
        className="header-sublevel-option"
        style={{ fontSize: '12px', textAlign: 'left' }}
        key={sublevel.name}
      >
        - {sublevel.name}
      </div>
    );
  }
};

export const LinkComponent = (props) => {
  const { history, index, link, openFirstLevel, closeFirstLevel, userRole } =
    props;

  let user = authService?.getUser()
  if (
    user?.roles[0]?.code === salesRoles?.SALES_COUNTER &&
    user?.type === 'Externo' &&
    ['Módulos', 'Administración', 'Configuración'].includes(link?.name)
  ) {
    return null;
  }

  let selected = '';


  if (window?.location?.href?.includes(link.link)) {
    selected = true;
  }

  // Desbloquear para esconder los elementos del header segun rol

  // if (!link?.roles?.includes(auth.getUserType())) {
  //   return null;
  // }

  if (link?.roles?.length > 0 && !link?.roles?.includes(auth.getUserType())) {
    return null;
  }
  if (link?.levels?.length > 0) {
    return (
      <>
        {link?.isOpen && (
          <div
            className="header-sublevel-container"
            onClick={() => closeFirstLevel()}
          ></div>
        )}
        <div
          className={`link-component link-component-${selected}`}
          onClick={
            link.isOpen ? () => closeFirstLevel() : () => openFirstLevel(index)
          }
        >
          <img className="link-component-logo" src={link.src} alt="icon" />
          <span>{link.name}</span>
          <img
            className="link-component-arrow"
            src={navOptionArrow}
            alt="navOptionArrow"
          />

          {link?.isOpen && (
            <div className="header-sublevel-section">
              {link.levels?.map((l) => (
                <LevelComponent
                  key={l.url}
                  link={link}
                  level={l}
                  closeFirstLevel={closeFirstLevel}
                  history={history}
                  userRole={userRole}
                />
              ))}
            </div>
          )}
        </div>
      </>
    );
  } else {
    return (
      <div
        className={`link-component link-component-${selected}`}
        onClick={() => closeFirstLevel()}
      >
        <NavLink to={`/` + link.link}>
          <img className="link-component-logo" src={link.src} alt="icon" />
          <span>{link.name}</span>
        </NavLink>
      </div>
    );
  }
};

export const Header = () => {
  const history = useHistory();
  const [linkOptions, setLinkOptions] = useState(linksVentas);
  const [userRole, setUserRole] = useState('');
  const [logOutModal, setLogOutModal] = useState({
    isOpen: false,
  });
  const inboxCount = useInboxCountStore((state) => state.inboxCount);
  const isSocketConnected = useSocketConnectionStore((state) => state.isConnected);

  let user = localStorage.getItem('user');
  user = JSON.parse(user);

  const openFirstLevel = (index) => {
    let links = linkOptions;
    for (let i = 0; i < links?.length; i++) {
      links[i].isOpen = false;
    }
    links[index].isOpen = true;

    setLinkOptions((prevState) => {
      return [...links];
    });
  };

  const closeFirstLevel = (index) => {
    let links = linkOptions;
    for (let i = 0; i < links?.length; i++) {
      links[i].isOpen = false;
    }

    setLinkOptions((prevState) => {
      return [...links];
    });
  };

  const redirectHome = () => {
    if (history.location.pathname === '/dashboard/analytics') {
      window.location.reload();
    } else {
      history.push('/dashboard/analytics');
    }
  };

  const handleLogoutModal = () => {
    setLogOutModal((prevState) => {
      return {
        ...prevState,
        isOpen: !logOutModal?.isOpen,
      };
    });
  };
  const signOut = () => {
    handleLogoutModal();
    disconnectSocket();
    localStorage.clear();
    history.push('/login');
  };

  const getUser = () => {
    const response = authService?.getUser();
    setUserRole(response);
  };

  useEffect(() => {
    getUser();
    const token = auth.getToken();
    const userData = auth.getUser();
    if (token && userData?._id) {
      connectSocket(userData._id, token);
    }
  }, []);

  if (!user?.firstName) {
    return null;
  } else {
    return (
      <>
        <LogOutModal
          modal={logOutModal}
          handleModal={handleLogoutModal}
          action={signOut}
        />
        <div className="header-component">
          <div className="header-links-container">
            <div className="navbar-options-container">
              <img
                onClick={() => redirectHome()}
                src={logo}
                alt="logo"
                className="header-logo"
              />
              {linkOptions?.map((l, i) => (
                <LinkComponent
                  key={l.name}
                  index={i}
                  link={l}
                  openFirstLevel={openFirstLevel}
                  closeFirstLevel={closeFirstLevel}
                  history={history}
                  userRole={userRole}
                />
              ))}
            </div>
            {

            }
            <div className="header-name-settins-container">
              {
                [SALES_COUNTER]?.includes(authService?.getUserType()) && (
                  <ActionButton
                    type="button"
                    action={() => {
                      navigator.clipboard.writeText(`${window.location.origin}/retail/${user?.saleChannel}`);
                      notify('Link copiado', 'success')
                    }}
                    label={'Link'}
                  />
                )
              }
              {[SALES_DEVELOPER, SALES_ADMIN, SALES_SUPERVISOR, SALES_ADMIN_AUX, SALES_COUNTER, SALES_FARMER, SALES_HUNTER, SALES_KEY_ACCOUNTS]?.includes(authService?.getUserType()) && (
                <div onClick={() => history.push('/dashboard/inbox')} style={{ cursor: 'pointer', position: 'relative', display: 'inline-block' }}>
                  <img style={{ height: '30px', marginBottom: '4px' }} src={letter} alt="inbox" />
                  {inboxCount > 0 && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '-6px',
                        right: '10px',
                        minWidth: '18px',
                        height: '18px',
                        padding: '0 4px',
                        fontSize: '11px',
                        fontWeight: 600,
                        color: 'white',
                        backgroundColor: '#e74c3c',
                        borderRadius: '9px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {inboxCount > 99 ? '99+' : inboxCount}
                    </span>
                  )}
                </div>
              )}
              <span
                className="socket-status-label"
                style={{
                  marginRight: '12px',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: isSocketConnected ? '#27ae60' : '#e74c3c',
                }}
                title={isSocketConnected ? 'Conectado' : 'Desconectado'}
              />
              <h6>
                {user?.firstName} {user?.lastName} (
                {transcriptRoles(user?.roles[0]?.code)})
                <span
                  style={{ marginLeft: '12px', textTransform: 'uppercase' }}
                >
                  {readRole(user?.roles[0]?.code)}
                </span>
              </h6>
              <img
                onClick={() => handleLogoutModal()}
                src={threedots}
                alt={'threedots'}
              ></img>
            </div>
          </div>
        </div>
      </>
    );
  }
};
